import { render, staticRenderFns } from "./EventApprovalModal.vue?vue&type=template&id=eee5061c&scoped=true"
import script from "./EventApprovalModal.vue?vue&type=script&lang=js"
export * from "./EventApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee5061c",
  null
  
)

export default component.exports